/* Progressive navigation: no legal copy is rewritten or moved. */
(() => {
  const root = document.querySelector('[data-fd-legal]');
  const body = root?.querySelector('.shopify-policy__body');
  if (!body) return;
  const headings = [...body.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
  if (headings.length >= 4 && body.textContent.trim().length >= 2500) {
    const details = document.createElement('details');
    details.className = 'fd-legal__index';
    const summary = document.createElement('summary');
    summary.textContent = root.dataset.indexLabel;
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', root.dataset.indexLabel);
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = `fd-policy-heading-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
        heading.dataset.fdGeneratedId = '';
      }
      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'fd-legal__subheading';
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
    });
    nav.append(list);
    details.append(summary, nav);
    body.before(details);
  }
  // Keyboard access to horizontal table scrolling without changing cell markup.
  body.querySelectorAll('table').forEach(table => {
    if (!table.hasAttribute('tabindex')) table.tabIndex = 0;
  });
})();
